module.exports = __webpack_public_path__ + "static/media/springs.04264626.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/springs.svg
// module id = 370
// module chunks = 0